import { SrFaxManagementApi } from "../../../services";
import { getConfigObject, getXtenantId, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  faxUuid: string;
  isRead: boolean;
}

  export const useFaxMarkAsRead = () =>
  useMutationWithLoading(async (params: Params) =>
    new SrFaxManagementApi(getConfigObject()).markAsRead1(
      params.faxUuid,
      params.isRead,
      getXtenantId()
    )
  );
